export default __webpack_public_path__ + "static/media/card-m-review@3x.202f8b88.png";